var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2146 3.54855H14.4646V2.11998C14.4646 2.02176 14.3843 1.94141 14.2861 1.94141H13.0361C12.9378 1.94141 12.8575 2.02176 12.8575 2.11998V3.54855H7.14321V2.11998C7.14321 2.02176 7.06285 1.94141 6.96463 1.94141H5.71463C5.61642 1.94141 5.53606 2.02176 5.53606 2.11998V3.54855H1.78606C1.39097 3.54855 1.07178 3.86775 1.07178 4.26284V19.0843C1.07178 19.4794 1.39097 19.7986 1.78606 19.7986H18.2146C18.6097 19.7986 18.9289 19.4794 18.9289 19.0843V4.26284C18.9289 3.86775 18.6097 3.54855 18.2146 3.54855ZM17.3218 18.1914H2.67892V9.70926H17.3218V18.1914ZM2.67892 8.19141V5.15569H5.53606V6.22712C5.53606 6.32534 5.61642 6.40569 5.71463 6.40569H6.96463C7.06285 6.40569 7.14321 6.32534 7.14321 6.22712V5.15569H12.8575V6.22712C12.8575 6.32534 12.9378 6.40569 13.0361 6.40569H14.2861C14.3843 6.40569 14.4646 6.32534 14.4646 6.22712V5.15569H17.3218V8.19141H2.67892Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1bbc45894369c401b6de10cd12cdff32.svg";
export { ForwardRef as ReactComponent };